import { useSelector } from 'react-redux';

export const useRoleActive = (targetRole) => {
  const { data: roles } = useSelector(state => state.allRoles);
  return roles.some((role) => (role.role === targetRole || role.base_role === targetRole) && role.is_active);
};
